<template>
  <DealDetail :deal="deal"/>
</template>

<script>
// @ is an alias to /src
import DealDetail from '@/components/DealDetail.vue';
import axios from 'axios';

export default {
  name: 'feed',
  components: {
    DealDetail,
  },
  data() {
    return {
      deal: {}
    };
  },
  mounted () {
    axios
      .get('https://apibeta.nimtu.com/v1/deals/' + this.$route.params.id)
      .then(response => (this.deal = response.data))
  }
};
</script>
